import React, { Component } from "react";
import Content from "../../content/Content";
import style from "../../assets/css/modules/health-support/cancer-services-item.css";
import SmartLink from "../shared/links/SmartLink";

export class CancerSupportItem extends Component {
  GetImage(src) {
    return <img src={src} alt="" aria-hidden />;
  }

  render() {
    return (
      <div className={style.CancerSupportItem}>
        <Content names={[this.props.IconSrc, this.props.Heading]}>
          {(src, alt) => this.GetImage(src)}
        </Content>
        <h3>
          <Content name={this.props.Heading} />
        </h3>
        <p>
          <Content name={this.props.Desc} />
        </p>
        <div className={style.links}>
          <Content name={this.props.Links}>
            {(links) =>
              links.map((link, key) => (
                <SmartLink
                  key={key}
                  to={link.LinkTo}
                  isExternalLink={link.ExtLink}
                >
                  <Content name={link.LinkText} />
                  <div className={style.hide}>
                    {link.AriaLabel}
                  </div>
                </SmartLink>
              ))
            }
          </Content>
        </div>
       
      </div>
    );
  }
}

export default CancerSupportItem;
